define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 时间间隔类型。
     *
     * @exports EnumTimeIntervalType
     *
     * @see Time#setTimeInterval
     */
    var EnumTimeIntervalType = {
        /**
         * 禁用回调。
         * @type {Number}
         * @constant
         */
        CALLBACK_NULL: 0,

        /**
         * 每帧触发。
         * @type {Number}
         * @constant
         */
        FRAME: 1,

        /**
         * 每秒触发。
         * @type {Number}
         * @constant
         */
        SECOND: 2,

        /**
         * 每半秒触发。
         * @type {Number}
         * @constant
         */
        HALF_SECOND: 3,

        /**
         * 每分钟触发。
         * @type {Number}
         * @constant
         */
        MINUTE: 4,

        /**
         * 每半分钟触发。
         * @type {Number}
         * @constant
         */
        HALF_MINUTE: 5,

        /**
         * 每小时触发。
         * @type {Number}
         * @constant
         */
        HOUR: 6,

        /**
        * 每半小时触发。
        * @type {Number}
        * @constant
        */
        HALF_HOUR: 7,

        /**
         * 每天触发。
         * @type {Number}
         * @constant
         */
        DAY: 8,

        /**
         * 每半天触发。
         * @type {Number}
         * @constant
         */
        HALF_DAY: 9
    }
    freezeObject(EnumTimeIntervalType)
    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {String} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumTimeIntervalType) {
            if (EnumTimeIntervalType.hasOwnProperty(key) && EnumTimeIntervalType[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        CALLBACK_NULL: 0,
        FRAME: 1,
        SECOND: 2,
        HALF_SECOND: 3,
        MINUTE: 4,
        HALF_MINUTE: 5,
        HOUR: 6,
        HALF_HOUR: 7,
        DAY: 8,
        HALF_DAY: 9,
        getName: getName
    }
})